import { CalendarItem } from 'utils/calendarItems';
import { FlexBlockDetails, FlexHoldDetails } from 'state/blocks';
import AppConstants from 'constants/AppConstants';

export function setFlexBlockDetails(flexBlockDetails: FlexBlockDetails): BaseTockAction {
  return {
    type: AppConstants.FLEX_BLOCKS_SET,
    payload: flexBlockDetails,
  };
}

export function clear(): BaseTockAction {
  return {
    type: AppConstants.FLEX_BLOCKS_CLEAR,
  };
}

export function setFlexHoldDetails(flexHoldDetails: FlexHoldDetails): BaseTockAction {
  return {
    type: AppConstants.FLEX_HOLD_SET,
    payload: flexHoldDetails,
  };
}

export function setCalendarItemToHold(calendarItem: CalendarItem): BaseTockAction {
  return {
    type: AppConstants.CALENDAR_ITEM_HOLD_SET,
    payload: calendarItem,
  };
}

export function showTicketSubsetHoldModal(show: boolean): BaseTockAction {
  return {
    type: AppConstants.CALENDAR_ITEM_SHOW_SUBSET_MODAL,
    payload: show,
  };
}
